const Grid = {
	MuiGrid: {
		defaultProps: {
			spacing: 0,
		},
	},
}
export default Grid
